<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-tooltip
      :disabled="disabledTooltip() || !isedite"
      :content="tooltip"
      placement="top-start"
    >
      <p v-if="isCreate()" :style="inputStyle">
        <el-button
          @click="createTeam"
          type="primary"
          size="small"
          :disabled="!editable"
          >创建队伍</el-button
        >
      </p>
      <el-input
        disabled
        :style="inputStyle"
        :type="type"
        :rows="rows"
        :placeholder="placeholder"
        v-model="val"
        ref="component"
        @keyup.enter.native="handleEnter"
        @blur="handleBlur"
        v-else-if="isCreateAndValue()"
      />
      <p
        v-else-if="teaminfo"
        :style="inputStyle"
        style="border: 1px solid #e4e7ed; padding: 5px"
      >
        <el-button @click="handelcopy(teaminfo.url)" type="danger" size="small"
          >复制邀请链接</el-button
        >
        <span style="font-size: 14px; color: #999; margin-left: 10px"
          >队伍代码:{{ teaminfo.id }}</span
        >
      </p>

      <el-input
        :disabled="!isedite"
        :style="inputStyle"
        :type="type"
        :rows="rows"
        :placeholder="placeholder"
        v-model="val"
        ref="component"
        @keyup.enter.native="handleEnter"
        @blur="handleBlur"
        v-else
      />
    </el-tooltip>
  </div>
</template>

<script>
import Validator from '../../utils/validator.js'
import PageModel from '../../models/page'
import { copy } from '../../utils/tool'

import _ from 'lodash'

export default {
  name: 'jtInput',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    minLength: {
      type: Number,
      default: 1,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    expression: {
      type: String,
      default: '',
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: this.maxLength >= 100 ? 'textarea' : 'text',
      rows: this.maxLength > 200 ? 8 : 5,
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
      teaminfo: null,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    isCreate() {
      if (this.value === '' && this.expression === '值=TEAMNAME()') {
        return true
      } else {
        return false
      }
    },

    isCreateAndValue() {
      if (this.value !== '' && this.expression === '值=TEAMNAME()') {
        return true
      } else {
        return false
      }
    },

    iscode() {},
    createTeam() {
      this.$emit('createTeam')
    },

    handelcopy(url) {
      let a = copy(url)
      if (a) {
        this.$message.success('复制成功！')
      }
    },

    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      if (this.type == 'text') {
        try {
          this.hasFiredEnterEventHandler = true
          this.$emit('enter')
          this._save()
        } catch (err) {
          this.$emit('datas', err, null)
        }
      }
    },
    handleBlur() {
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    _validate(value) {
      const min = this.minLength
      const max = this.maxLength
      const minErrMsg = this.$t('input.MIN_LENGTH', { min })
      const maxErrMsg = this.$t('input.MAX_LENGTH', { max })
      Validator.isLength(value, { min }, minErrMsg)
      Validator.isLength(value, { max }, maxErrMsg)
    },
    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        let str1 = value.replace(/[\f\r\t]/g, '')
        this._validate(str1)
        this.val = str1
        this.$emit('datas', null, str1)
      } else {
        this.$emit('datas', null, value)
      }
    },
  },

  mounted() {
    if (this.value !== '' && this.expression === '值=TEAMCODE()') {
      let that = this
      PageModel.getTeamInfo(this.value).then((data) => {
        if (data.errNo === 0) {
          that.teaminfo = data.payload
        }
      })
    }
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
}
</script>

<style lang="stylus">
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;

  label{
    line-height: 20px
  }
}

.component-container .is-disabled .el-input__inner {
  color: #666666;
}



.xing {
  color: #fff;
  margin-right: 5px;
}

@media screen and (max-width: 768px) {
  .component-container {
    flex-wrap: wrap;

    label {
      margin-bottom: 8px;
      margin-left: -10px;
    }
  }
}
</style>
